import actionTypes from './actionTypes'
import config from '../../../config/config'
import { isSentry } from '../../../lib'
import moment from 'moment'

const {
  PLAN_DETAILS
} = actionTypes

const APIurl = `${config.URI}/api/v1/get_contract`

function planStatus (data) {
  let contractStatus = ''
  if (data.domain.status == 'expire') {
    if (!data.expire_flag && data.domain.trial) {
      contractStatus = 'トライアル(有効)'
    } else if (data.expire_flag && data.domain.trial) {
      contractStatus = 'トライアル(期限切れ)'
    } else if (!data.expire_flag && !data.domain.trial) {
      contractStatus = '本契約(有効)'
    } else if (data.expire_flag && !data.domain.trial) {
      contractStatus = '本契約(期限切れ)'
    }
  } else if (data.domain.status == 'valid') {
    contractStatus = '本契約(有効)'
  } else if (data.status == 'invalid') {
    contractStatus = '本契約(無効)'
  }
  return contractStatus
}

export function fetchPlanDetails (token) {
  return function (dispatch) {
    return fetch(`${APIurl}`, {
      method: 'GET',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status && res.status === 'success') {
          let data = {}
          if (res.data.domain) {
            data.companyName = res.data.domain.name
            data.concurrency = res.data.domain.connections
            data.expirationDate = moment(res.data.domain.expire).format('YYYY-MM-DD')
            data.recordStorage = '5GB'
            data.currentAccount = res.data.domain.max_account_num
            data.domainUrlName = res.data.domain.fv_domains_name
            data.status = res.data.domain.status
            data.max_room_num_per_user = res.data.domain.max_room_num_per_user
            data.contractStatus = planStatus(res.data)
          }
          dispatch({type: PLAN_DETAILS, data})
        }
      })
      .catch((error) => {
        isSentry(error)
      })
  }
}





// WEBPACK FOOTER //
// ./src/components/PlanDetails/actions/index.js